<template>
  <ion-page>
    <ion-content :class="'main-background'" :fullscreen="true" slot="fixed" :scroll-y="false">
      <h1 class="ion-text-center white-bold">Смена пароля</h1>
      <ion-avatar>
        <ion-icon :icon="lockOpenOutline"></ion-icon>
      </ion-avatar>
      <div class="password-change-body">
        <ion-item lines="none">
          <ion-label class="password-label">Текущий пароль</ion-label>
          <ion-input type="password" v-model="currentPassword"></ion-input>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="password-label">Новый пароль</ion-label>
          <ion-input type="password" v-model="newPassword"></ion-input>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="password-label">Еще раз</ion-label>
          <ion-input type="password" v-model="newPasswordRetype"></ion-input>
        </ion-item>
        <ion-button @click="saveNewPassword()" class="save-button">
          Сохранить
        </ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from '@/model/globalcontext.model';
import { CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import {
    IonAvatar,
    IonButton,
    IonContent,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonPage,
    alertController,
} from '@ionic/vue';
import axios from 'axios';
import { lockOpenOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';

export default defineComponent({
  name: 'ChangePassword',
  components: {
    IonContent,
    IonPage,
    IonAvatar,
    IonItem,
    IonLabel,
    IonInput,
    IonButton,
    IonIcon,
  },
  setup() {
    const globalContext = inject('globalContext') as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      lockOpenOutline,
      isMobile,
    }
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      newPasswordRetype: '',
    }
  },
  methods: {
    async saveNewPassword() {
      if (this.currentPassword.trim() === '') {
        this.showAlert('Ошибка', 'Необходимо указать текущий пароль');
        return;
      }
      if (this.newPassword.trim() === '') {
        this.showAlert('Ошибка', 'Новый пароль не задан');
        return;
      }
      if (this.newPassword.length < 4) {
        this.showAlert('Ошибка', 'Минимальная длина - 4 символа');
        return;
      }
      if (this.newPassword !== this.newPasswordRetype) {
        this.showAlert('Ошибка', 'Пароли не совпадают');
        return;
      }

      const params = {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      };

      const tokenQuery = await Preferences.get({ key: 'jwt' });
      const token = tokenQuery.value;

      if (this.isMobile) {
        const options = {
          url: `${process.env.VUE_APP_API_URL}api/account/change-password`,
          data: params,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        };

        CapacitorHttp.post(options)
          .then((response) => {
            if (response.status === 400) {
              this.showAlert('Ошибка', 'Проверьте текущий пароль и попробуйте еще раз');
            } else {
              this.showAlert('Сообщение', 'Пароль успешно изменен');
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        axios
          .post('api/account/change-password', params)
          .then((response) => {
            if (response.status === 400) {
              this.showAlert('Ошибка', 'Проверьте текущий пароль и попробуйте еще раз');
            } else {
              this.showAlert('Сообщение', 'Пароль успешно изменен');
            }
          })
          .catch((err) => {
            if (err.message === 'Request failed with status code 400') {
              this.showAlert('Ошибка', 'Проверьте текущий пароль и попробуйте еще раз');
            }
          });
      }
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController
        .create({
          header: alertTitle,
          message: alertMessage,
          buttons: ['OK'],
        });

      await alert.present();
    }
  }

});
</script>

<style scoped>
h1 {
  margin-top: 20vh;
  letter-spacing: .08em;
}

ion-avatar {
  background: white;
  margin: auto;
  margin-top: 2em;
  margin-bottom: 5vh;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-avatar ion-icon {
  color: var(--ion-color-orange);
  font-size: 2em;
}

.password-label {
  --color: var(--ion-color-dark);
  width: 35%;
}

ion-item {
  --background: white;
  border-radius: 10px;
  margin-bottom: 1em;
  opacity: 0.9;
  --min-height: 20px;
  width: 80%;
}

.save-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.password-change-body {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}
</style>